import {PersonManage} from "@/interfaces/person-manage";
import {FormResponse} from "@/interfaces/form-response";
import {Service} from "@/services/superclasses/service";
import {PersonActivation} from "@/interfaces/person-activation";

const api = window.contextPath + '/rest/persons';

export class PersonService extends Service {

    public prepareNew = async (): Promise<PersonManage> => {
        return this.data(await this.get<PersonManage>(api + "/prepare-new"))
    };

    public create = async (data: PersonManage): Promise<FormResponse<PersonManage>> => {
        return this.data(await this.post<FormResponse<PersonManage>>(api, data))
    }

    public activate = async (data: PersonActivation): Promise<FormResponse<PersonActivation>> => {
        return this.data(await this.post<FormResponse<PersonActivation>>(api + "/activate", data));
    }

    public undelete = async (personId: number, token: string): Promise<void> => {
        return this.data(await this.post(`${api}/${personId}/undelete?token=${token}`));
    }

    public login = async (username: string, password: string, remember: boolean) : Promise<void> => {
        return this.data(await this.post(api + "/login",
            {"username": username, "password": password, "remember": remember},
            { headers: {'content-type': 'application/x-www-form-urlencoded'} }));
    }

    public resendActivationEmail = async (email: string): Promise<FormResponse<void>> => {
        return this.data(await this.post(`${api}/resend-activation-email?email=${email}`))
    }
}

export const personService = new PersonService();